import { useLayoutEffect, useRef } from 'react';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface RenderInBodyProps {
  children: ReactNode;
  containerClassName?: string;
  containerStyles?: string;
}

const RenderInBody = ({ children, containerClassName, containerStyles }: RenderInBodyProps) =>
{
  const elementRef = useRef<HTMLDivElement | null>(null);

  // Crear el elemento solo una vez
  if (!elementRef.current)
  {
    elementRef.current = document.createElement('div');
  }

  useLayoutEffect(() =>
  {
    const element = elementRef.current;

    if (!element) return;

    // Agregar al body cuando el componente se monta
    document.body.appendChild(element);

    // Cleanup: remover del body cuando se desmonta
    return () =>
    {
      document.body.removeChild(element);
    };
  }, []); // Solo se ejecuta al montar/desmontar

  useLayoutEffect(() =>
  {
    // Actualizar className
    if (elementRef.current && containerClassName)
    {
      elementRef.current.className = containerClassName;
    }
  }, [containerClassName]);

  useLayoutEffect(() =>
  {
    // Actualizar styles
    if (elementRef.current && containerStyles)
    {
      elementRef.current.style.cssText = containerStyles;
    }
  }, [containerStyles]);

  // Usar createPortal para renderizar children en el elemento
  return elementRef.current ? createPortal(children, elementRef.current) : null;
};

export default RenderInBody;
